import Filter, { FilterType } from '../models/Filter';

import DateFilterChip from './DateFilterChip';
import DropdownFilterChip from './DropdownFilterChip';
import TextFilterChip from './TextFilterChip';

interface FilterChipProps {
  filter: Filter;
  onClick?: (filter: Filter) => void;
  onDelete?: (filter: Filter) => void;
  onClosePopover?: (oldFilter: Filter, newFilter?: Filter) => void;
}

const FilterChip = ({ filter, onClick, onDelete, onClosePopover }: FilterChipProps) => {
  switch (filter.type) {
    case FilterType.Date:
      return (
        <DateFilterChip
          filter={filter}
          onClick={onClick}
          onDelete={onDelete}
          onClosePopover={onClosePopover}
          data-testid="date-filter-chip"
        />
      );
    case FilterType.Text:
      return (
        <TextFilterChip
          filter={filter}
          onClick={onClick}
          onDelete={onDelete}
          onClosePopover={onClosePopover}
          data-testid="text-filter-chip"
        />
      );
    case FilterType.Number:
      return (
        <TextFilterChip
          filter={filter}
          onClick={onClick}
          onDelete={onDelete}
          onClosePopover={onClosePopover}
          data-testid="number-filter-chip"
        />
      );
    default:
      return (
        <DropdownFilterChip
          filter={filter}
          onClick={onClick}
          onDelete={onDelete}
          onClosePopover={onClosePopover}
          data-testid="dropdown-filter-chip"
        />
      );
  }
};

export { FilterChipProps };
export default FilterChip;
